import React, { FC, memo } from 'react'

import { Element } from 'react-scroll'

import { icons } from '@/constants/icons'
import { useCommonTranslation } from '@/i18n/useCommonTranslation'
import { SelectOptionProps } from '@/types/componentsPropsTypes'

import { SelectOptionElem } from './styles'

const SelectOptionRaw: FC<SelectOptionProps> = ({
  selectOption,
  onSelected,
  isActive,
}) => {
  const { t } = useCommonTranslation()

  return (
    <SelectOptionElem
      elementType="div"
      onSelected={onSelected}
      focusId={selectOption.id}
      $isActive={isActive}
    >
      <Element name={selectOption.id}>
        {selectOption.imageSrc && (
          <img
            src={selectOption.imageSrc}
            alt=""
            onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
              const target = e.target as HTMLImageElement
              target.style.opacity = '0'
            }}
          />
        )}
        <span>{t(selectOption.label)}</span>
        {isActive && (
          <img className={'checked'} src={icons.navigation.check} alt="" />
        )}
      </Element>
    </SelectOptionElem>
  )
}

export const SelectOption = memo(SelectOptionRaw)
